<div appClickOutside (clickOutside)="showColors(false)" class="color-container" [attr.disabled]="disabled ? true : undefined">
    <div [matTooltip]="disabledText" matTooltipPositionAtOrigin="true">
        <div class="color-container-color dropdown" (click)="showColors()" [ngStyle]="{'background-color': selectedColor}" [attr.data-testid]="testId || undefined"></div>
        <div class="color-container-list" *ngIf="showColorList"
            [ngClass]="openDirection" [ngStyle]="{'grid-template-columns': 'repeat(' + columns + ', 1fr)'}"
            [attr.data-testid]="testId ? testId + '-List' : undefined"
        >
            <div
                *ngFor="let k of colorOptions; let i = index"
                (click)="pickColor(k)"
                class="color-container-color option"
                [ngStyle]="{'background-color': k}"
                [attr.data-testid]="testId ? testId + '-Option-' + i : undefined"
            ></div>
            <div *ngIf="noColorButton" class="no-color option" (click)="pickColor(null)" [ngStyle]="{'grid-column': 'span ' + columns}"
                [attr.data-testid]="testId ? testId + '-NoColor' : undefined">
                 {{ 'generics.no-color' | translate }}
            </div>
        </div>
    </div>
</div>
